import type { NodeV2 } from '@vedalib/editor'
import { isComplexElement, isNodeV2 } from '@vedalib/editor'
import type { EditorElement, ElementsTypes } from '@vedalib/editor/lib/elements'
import { generateId } from '@vedalib/editor/lib/utils/id'
import * as R from 'ramda'
import React, { useCallback } from 'react'

import { generateElement } from 'components/Editor/EditorElements/elements.config'
import type { IPickerElement } from 'components/Editor/EditorElements/pickerConfig/elementsPicker.types'
import { genNode, genSubLayout } from 'components/Editor/NodeV2/constants'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { preventDefault } from 'constants/commonConstans'
import type { Block, MapType } from 'services/Store/Project/types'

import { remapComplexNode } from '../complexNodes'
import * as s from './TileElement.module.scss'

interface ITileElementProps {
  block: Block
  item: IPickerElement
  parent: NodeV2
  onAdd: (
    node: NodeV2,
    data?: { nodes?: MapType<NodeV2>; elements?: MapType<EditorElement> },
  ) => void
}

const TileElement: React.FC<ITileElementProps> = ({ item, block, onAdd }) => {
  const handleAddElement = useCallback(async () => {
    const element = generateElement(item.type as ElementsTypes)
    const root = genNode(generateId(), { elementId: element?.id })
    const data = {
      elements: { [element.id]: element },
      nodes: {
        ...(isComplexElement(element) &&
          R.indexBy(
            R.prop('id'),
            element.value.items.map((item) => {
              const existNode = block?.schema.nodes[item.value]
              return isNodeV2(existNode) ? existNode : genSubLayout(item.value)
            }),
          )),
      },
    }

    const newData = remapComplexNode({
      root: root,
      elements: data.elements,
      nodes: { ...data.nodes, [root.id]: root },
    })

    onAdd(newData.root, newData)
  }, [onAdd, block?.schema.nodes, item])

  return (
    <div className={s.root} key={item.type} onClick={handleAddElement}>
      <div className={s.icon} onMouseDown={preventDefault}>
        {item.icon}
      </div>
      <Typography size={KitSize.S} textAlign='center'>
        {item.label}
      </Typography>
    </div>
  )
}

export default TileElement
